(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[13189,19341,97,68837],{

/***/ 45783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ getContentfulImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);


var getContentfulImage = function(_param) {
    var src = _param.src, width = _param.width, quality = _param.quality, progressive = _param.progressive, format = _param.format, transparent = _param.transparent, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "src",
        "width",
        "quality",
        "progressive",
        "format",
        "transparent"
    ]);
    try {
        var url = new URL(src);
        var fm = format || (transparent ? "webp" : "jpg");
        if (!format && src.includes(".svg")) {
            fm = null;
        }
        if (fm === "jpg") {
            fm = "webp";
        }
        fm && url.searchParams.set("fm", fm);
        width && url.searchParams.set("w", width);
        quality && url.searchParams.set("q", quality);
        Object.entries(params).forEach(function(param) {
            var _$_param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _$_param[0], value = _$_param[1];
            return key && value && url.searchParams.set(key, value);
        });
        return url.href;
    } catch (e) {
        return src;
    }
};


/***/ }),

/***/ 34190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Media; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/components/Media/utils/helpers.js
var videoFormats = function(format) {
    return [
        "video/mp4",
        "video/webm", 
    ].includes(format);
};

;// CONCATENATED MODULE: ./UI/components/Media/utils/useMediaProps.js







/* harmony default export */ function useMediaProps(_param) {
    var asset = _param.asset, className = _param.className, isStatic = _param.isStatic, transparent = _param.transparent, loaderParams = _param.loaderParams, displayParams = _param.displayParams, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "asset",
        "className",
        "isStatic",
        "transparent",
        "loaderParams",
        "displayParams"
    ]);
    var ref = (0,react.useRef)(null);
    var ref1 = get_default()(asset, "fields", {}), contentType = ref1.file.contentType;
    var isVideo = videoFormats(contentType);
    var ref2 = (0,helper/* getImage */.gJ)(asset), url = ref2.url, alt = ref2.alt;
    var imageProps = (0,_object_spread/* default */.Z)({
        alt: alt,
        src: displayParams ? (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            src: url
        }, displayParams)) : url,
        layout: "fill",
        lazyBoundary: "700px",
        unoptimized: true,
        loader: isStatic ? function(param) {
            var src = param.src;
            return src;
        } : function(args) {
            return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
                transparent: transparent
            }, args, loaderParams));
        }
    }, rest);
    return (0,_object_spread/* default */.Z)({
        ref: ref,
        url: url,
        isVideo: isVideo,
        className: className,
        imageProps: imageProps
    }, rest);
};

// EXTERNAL MODULE: ./UI/components/Media/styles.module.scss
var styles_module = __webpack_require__(6992);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Media/index.jsx










var Media = function(_param) {
    var renderVideoPlayer = _param.renderVideoPlayer, props = (0,_object_without_properties/* default */.Z)(_param, [
        "renderVideoPlayer"
    ]);
    var _ref = useMediaProps(props), ref = _ref.ref, url = _ref.url, isVideo = _ref.isVideo, className = _ref.className, imageProps = _ref.imageProps, playControl = _ref.playControl, posterUrl = _ref.posterUrl, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "ref",
        "url",
        "isVideo",
        "className",
        "imageProps",
        "playControl",
        "posterUrl"
    ]);
    if (isVideo) {
        if (renderVideoPlayer) {
            return renderVideoPlayer({
                src: url,
                description: imageProps.alt
            });
        }
        if (playControl) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["video-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    ref: ref,
                    controls: true,
                    poster: posterUrl,
                    className: className
                }, rest), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: url,
                            type: "video/mp4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: url,
                            type: "video/webm"
                        })
                    ]
                }))
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref,
            muted: true,
            autoPlay: true,
            loop: true,
            playsInline: true,
            className: className
        }, rest), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: url,
                    type: "video/webm"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: url,
                    type: "video/mp4"
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()((styles_module_default()).image, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, imageProps))
    });
};
Media.propTypes = {
    asset: prop_types_default().instanceOf(Object).isRequired,
    autoPlay: (prop_types_default()).bool,
    loop: (prop_types_default()).bool,
    playsInline: (prop_types_default()).bool,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    renderVideoPlayer: (prop_types_default()).func
};
/* harmony default export */ var components_Media = (Media);


/***/ }),

/***/ 54255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getSegmentText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var getSegmentText = function(text) {
    var parts = text.split(/(~~.*?~~)/g);
    return parts.map(function(part) {
        var isAlpa = /^~~.*~~$/.test(part);
        if (isAlpa) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-title-alpha": true,
                style: {
                    display: "inline"
                },
                children: part.slice(2, -2)
            }, part);
        }
        return part;
    });
};


/***/ }),

/***/ 59654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18422);






var Typography = function(props) {
    var _ref = (0,_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .useTypography */ .tj)(props), Tag = _ref.Tag, classes = _ref.classes, children = _ref.children, onClick = _ref.onClick, tabIndex = _ref.tabIndex, role = _ref.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "Tag",
        "classes",
        "children",
        "onClick",
        "tabIndex",
        "role"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest), {
        children: children
    }));
};
Typography.defaultProps = {
    variant: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
    size: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16
};
Typography.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    isBold: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    mobileSize: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 13189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_PageIntroSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/Figures/index.jsx + 3 modules
var Figures = __webpack_require__(84486);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./UI/components/Typography/utils/useTypography.js
var useTypography = __webpack_require__(18422);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/constants/linkType.js
var constants_linkType = __webpack_require__(45177);
// EXTERNAL MODULE: ./UI/components/CallToAction/index.jsx + 1 modules
var CallToAction = __webpack_require__(49617);
// EXTERNAL MODULE: ./UI/components/SectionTitle/utils/get-segment-text.js
var get_segment_text = __webpack_require__(54255);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./UI/components/Media/index.jsx + 2 modules
var Media = __webpack_require__(34190);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ./UI/sections/PageIntroSection/utils/useSectionProps.js


/* harmony default export */ function useSectionProps(param) {
    var introSection = param.introSection, section = param.section, type = param.type, handleOnCTAClick = param.handleOnCTAClick;
    var ref = (0,helper/* getDocumentFields */.OA)(section, [
        "title",
        "description",
        "images",
        "contentModules",
        "formattedDescription",
        "subtitle", 
    ]), title = ref.title, description = ref.description, formattedDescription = ref.formattedDescription, subtitle = ref.subtitle, images = ref.images, contentModules = ref.contentModules;
    var image = (0,helper/* getImage */.gJ)(get_default()(images, "[0]", {}));
    var figuresData = contentModules === null || contentModules === void 0 ? void 0 : contentModules.find(function(module) {
        var ref = (0,helper/* getDocumentFields */.OA)(module, [
            "contentModules"
        ]), figures = ref.contentModules;
        return figures;
    });
    var imagesBundles = (0,helper/* getDocumentFields */.OA)(contentModules === null || contentModules === void 0 ? void 0 : contentModules[0], [
        "imagesBundles"
    ]).imagesBundles;
    var links = contentModules === null || contentModules === void 0 ? void 0 : contentModules.filter(function(module) {
        var ref = (0,helper/* getDocumentFields */.OA)(module, [
            "type", 
        ]), linkType = ref.type;
        return linkType === "button" || linkType === "scroll-to-section";
    });
    var ctaLinks = contentModules === null || contentModules === void 0 ? void 0 : contentModules.filter(function(module) {
        var ref = (0,helper/* getDocumentFields */.OA)(module, [
            "type", 
        ]), linkType = ref.type;
        return linkType === "scroll-block";
    });
    return {
        type: type,
        introSection: introSection,
        title: title,
        description: description,
        formattedDescription: formattedDescription,
        subtitle: subtitle,
        image: image,
        imagesBundles: imagesBundles,
        figuresData: figuresData,
        handleOnCTAClick: handleOnCTAClick,
        links: links,
        ctaLinks: ctaLinks
    };
};

// EXTERNAL MODULE: ./UI/sections/PageIntroSection/styles.module.scss
var styles_module = __webpack_require__(33731);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/PageIntroSection/index.jsx


















var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var Typography = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 59654));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59654)
            ];
        }
    }
});
var Button = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 49105).then(__webpack_require__.bind(__webpack_require__, 49105));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49105)
            ];
        }
    }
});
var PageIntroSection = function(props) {
    var ref = useSectionProps(props), type = ref.type, title = ref.title, description = ref.description, formattedDescription = ref.formattedDescription, subtitle = ref.subtitle, image = ref.image, figuresData = ref.figuresData, imagesBundles = ref.imagesBundles, introSection = ref.introSection, handleOnCTAClickCommon = ref.handleOnCTAClick, links = ref.links, ctaLinks = ref.ctaLinks;
    // TODO: use rich text instead of splitting
    var descriptionParagraphs = description === null || description === void 0 ? void 0 : description.split("||");
    var handleOnCTAClick = function(param) {
        var linkType = param.linkType, url = param.url;
        return function() {
            if (linkType === constants_linkType/* LINK_TYPE.scrollToSection */.x.scrollToSection) {
                var element = document.getElementById(url);
                window.scrollBy({
                    top: element.getBoundingClientRect().top - constants/* HEADER_HEIGHT */.Mz - 50,
                    behavior: "smooth"
                });
            } else {
                handleOnCTAClickCommon();
            }
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ref: introSection,
        className: classnames_default()((styles_module_default()).pageIntroSection, (styles_module_default())[type]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).contentWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).pageWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).pageTextContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                                        children: title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                                            variant: "h1",
                                            size: useTypography/* TYPOGRAPHY_SIZE.headline46 */.y3.headline46,
                                            mobileSize: useTypography/* TYPOGRAPHY_SIZE.headline24 */.y3.headline24,
                                            className: (styles_module_default()).pageTitle,
                                            children: (0,get_segment_text/* getSegmentText */.d)(title)
                                        })
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                                        children: descriptionParagraphs === null || descriptionParagraphs === void 0 ? void 0 : descriptionParagraphs.map(function(text, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                                                variant: "p",
                                                className: (styles_module_default()).pageSubtitle,
                                                children: text
                                            }, "paragraph/".concat(index));
                                        })
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                                        children: subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                                            variant: "p",
                                            className: (styles_module_default()).pageSubtitleSmall,
                                            children: subtitle
                                        })
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                                        children: formattedDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            "data-description": true,
                                            className: (styles_module_default()).formattedDescription,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                                                document: formattedDescription
                                            })
                                        })
                                    })),
                                    (links === null || links === void 0 ? void 0 : links.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).buttonWrapper,
                                        children: links === null || links === void 0 ? void 0 : links.map(function(link, index) {
                                            var ref = (0,helper/* getDocumentFields */.OA)(link, [
                                                "buttonTitle",
                                                "url",
                                                "type", 
                                            ]), url = ref.url, buttonTitle = ref.buttonTitle, linkType = ref.type;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                                    onClick: url && linkType !== constants_linkType/* LINK_TYPE.scrollToSection */.x.scrollToSection ? null : handleOnCTAClick({
                                                        linkType: linkType,
                                                        url: url
                                                    }),
                                                    className: classnames_default()((styles_module_default()).button, (styles_module_default())["button-".concat(index + 1)]),
                                                    href: linkType !== constants_linkType/* LINK_TYPE.scrollToSection */.x.scrollToSection ? url : null,
                                                    "data-button": true,
                                                    children: buttonTitle
                                                })
                                            }), "".concat(link.url, "-").concat(link.buttonTitle));
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                                children: image.url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                                    src: image.url,
                                    alt: image.alt,
                                    className: (styles_module_default()).pageImage,
                                    transparent: true,
                                    priority: true
                                })
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Figures/* Figures */.N, {
                        type: type,
                        figuresData: figuresData
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).bundleImagesContainer,
                        children: imagesBundles === null || imagesBundles === void 0 ? void 0 : imagesBundles.map(function(imageItem, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Media["default"], {
                                priority: true,
                                transparent: true,
                                className: classnames_default()((styles_module_default()).bundleImage, (styles_module_default())["bundleImage-".concat(index + 1)]),
                                asset: imageItem
                            }, "intro-images-bundles/".concat(imageItem.url));
                        })
                    })
                ]
            }),
            !!(ctaLinks === null || ctaLinks === void 0 ? void 0 : ctaLinks.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction["default"], {
                data: ctaLinks[0],
                className: (styles_module_default()).callToAction,
                sectionRef: introSection
            })
        ]
    });
};
PageIntroSection.defaultProps = {
    introSection: null
};
PageIntroSection.propTypes = {
    section: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string.isRequired,
    introSection: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var sections_PageIntroSection = (PageIntroSection);


/***/ }),

/***/ 92870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86437);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74129);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40659);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96076);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6572);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var UI_components_Media__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34190);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69123);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);













var Animated = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var GalleryCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 34378).then(__webpack_require__.bind(__webpack_require__, 34378));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34378)
            ];
        }
    }
});
var ArticleLink = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(13107), __webpack_require__.e(17396)]).then(__webpack_require__.bind(__webpack_require__, 7002)).then(function(module) {
        return module.ArticleLink;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7002)
            ];
        }
    }
});
var Table = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 84059).then(__webpack_require__.bind(__webpack_require__, 84059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84059)
            ];
        }
    }
});
var EmbedArticleCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 80931).then(__webpack_require__.bind(__webpack_require__, 80931));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80931)
            ];
        }
    }
});
var Illustration = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 93812).then(__webpack_require__.bind(__webpack_require__, 93812));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93812)
            ];
        }
    }
});
// TODO move it to the common folder
// TODO create constants for cases
var ContentfulParser = function(param) {
    var document = param.document, linkIcon = param.linkIcon;
    var _obj, _obj1;
    var options = {
        renderMark: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.CODE, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sub", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.BOLD, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.ITALIC, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.UNDERLINE, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                children: node
            });
        }), _obj),
        renderNode: (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.EMBEDDED_ENTRY, function(node) {
            var id = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target.sys.contentType.sys.id", "");
            switch(id){
                case "image":
                    {
                        var ref = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", ""), [
                            "articleSingleImageType",
                            "image",
                            "title"
                        ]), articleSingleImageType = ref.articleSingleImageType, rawImage = ref.image, title = ref.title;
                        var image = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getImage */ .gJ)(rawImage);
                        var _obj;
                        return articleSingleImageType && image.url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().imageWrapper),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().normalImage), articleSingleImageType === "normal"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().fullImage), articleSingleImageType !== "normal"), _obj)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, {
                                        type: utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .ANIMATED_TYPE.imageZoom */ .BK.imageZoom,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Illustration, {
                                            src: image.url,
                                            alt: image.alt,
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().image)
                                        })
                                    }),
                                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().photoCaption),
                                        children: title
                                    })
                                ]
                            })
                        });
                    }
                case "articleGalleryCard":
                    {
                        var ref1 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {}), [
                            "images",
                            "photoCaption"
                        ]), images = ref1.images, photoCaption = ref1.photoCaption;
                        return images && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GalleryCard, {
                            images: images,
                            photoCaption: photoCaption
                        });
                    }
                case "link":
                    {
                        var data = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        var ref2 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(data, [
                            "title",
                            "buttonTitle",
                            "slug",
                            "type",
                            "url",
                            "new", 
                        ]), title1 = ref2.title, buttonTitle = ref2.buttonTitle, slug = ref2.slug, type = ref2.type, url = ref2.url, isNew = ref2.new;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArticleLink, {
                            data: data,
                            new: isNew,
                            title: title1,
                            buttonTitle: buttonTitle,
                            slug: slug,
                            type: type,
                            url: url,
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().videoSection)
                        });
                    }
                case "table":
                    {
                        var ref3 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {}), [
                            "tableContent",
                            "tableType",
                            "tableText"
                        ]), tableContent = ref3.tableContent, tableType = ref3.tableType, tableText = ref3.tableText;
                        return (tableContent || tableText) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Table, {
                            tableData: tableText ? (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .extractContentfulTableData */ .cc)(tableText) : tableContent.tableData,
                            type: tableType
                        });
                    }
                case "article":
                    {
                        var data1 = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EmbedArticleCard, {
                            data: data1
                        });
                    }
                case "text":
                    {
                        var data2 = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        var ref4 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(data2, [
                            "text",
                            "id"
                        ]), text = ref4.text, entryId = ref4.id;
                        return(// eslint-disable-next-line react/no-unknown-property
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            "grid-area": entryId,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentfulParser, {
                                document: text
                            })
                        }));
                    }
                default:
                    return null;
            }
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.EMBEDDED_ASSET, function(node) {
            var data = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
            return(// eslint-disable-next-line react/no-unknown-property
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                "grid-area": "asset",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Media__WEBPACK_IMPORTED_MODULE_10__["default"], {
                    asset: data
                })
            }));
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.PARAGRAPH, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.QUOTE, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("blockquote", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().quote),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_1, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_2, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().h2),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_3, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().h3),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.UL_LIST, function(node, children) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ul),
                children: children === null || children === void 0 ? void 0 : children.map(function(child) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: child.props.children
                    }, child.key);
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.OL_LIST, function(node, children) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                type: "1",
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ol),
                children: children === null || children === void 0 ? void 0 : children.map(function(child) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: child.props.children
                    }, child.key);
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.INLINES.HYPERLINK, function(node, children) {
            var uri = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.uri", "/");
            var isInternalLink = uri.includes(utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .rootUrl */ .Wd);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                path: uri,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().a),
                isLocalLink: isInternalLink,
                children: [
                    children,
                    linkIcon
                ]
            });
        }), _obj1)
    };
    return document ? (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__/* .documentToReactComponents */ .h)(document, options) : "";
};
ContentfulParser.defaultProps = {
    document: null
};
ContentfulParser.propTypes = {
    document: prop_types__WEBPACK_IMPORTED_MODULE_12___default().instanceOf(Object)
};
/* harmony default export */ __webpack_exports__["default"] = (ContentfulParser);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 6992:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__NnBr_","video-container":"styles_video-container__3YIN0","play-button":"styles_play-button__ubn_b"};

/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ }),

/***/ 33731:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsWithFullWidthImage":"styles_cardsWithFullWidthImage___Bapj","cards":"styles_cards__gHk8o","imageWrapper":"styles_imageWrapper__3Hu3q","typeTitle":"styles_typeTitle__bRvFE","greySection":"styles_greySection__Nzrt4","callToAction":"styles_callToAction__ngxRV","threeColumnsCards":"styles_threeColumnsCards__PxzIP","twoColumnsCards":"styles_twoColumnsCards__73XOU","textContent":"styles_textContent__2U90V","pageIntroSection":"styles_pageIntroSection__wrkmV","contentWrapper":"styles_contentWrapper__68TIO","pageWrapper":"styles_pageWrapper__pyXeq","pageTextContainer":"styles_pageTextContainer__avVmC","pageTitle":"styles_pageTitle__KAhQs","pageSubtitle":"styles_pageSubtitle__oJ7jY","pageImage":"styles_pageImage__Gx9l6","buttonWrapper":"styles_buttonWrapper__XCPtE","button":"styles_button__O9HmA","ios-mobile-app-development-services":"styles_ios-mobile-app-development-services__bJ2_L","artificial-intelligence-development-services":"styles_artificial-intelligence-development-services__pBzbl","chat-app-development-company":"styles_chat-app-development-company__NhjVO","devops-development-services":"styles_devops-development-services__m7oR0","enterprise-resource-planning-software-services":"styles_enterprise-resource-planning-software-services__A3QP1","fintech-software-development-services":"styles_fintech-software-development-services__HFXDp","machine-learning-development-services":"styles_machine-learning-development-services__D79ii","mobile-app-development-company":"styles_mobile-app-development-company__lQuHQ","ui-ux-services":"styles_ui-ux-services__GMkez","web-app-development-company":"styles_web-app-development-company__7w1Wy","discovery-phase-services":"styles_discovery-phase-services__w3AFZ","mvp-app-development-company":"styles_mvp-app-development-company__xzQn7","android-mobile-app-development-services":"styles_android-mobile-app-development-services__g9jbX","cloud-based-app-development-services":"styles_cloud-based-app-development-services__cXLhf","cross-platform-development-services":"styles_cross-platform-development-services__MMzcE","data-science-development-company":"styles_data-science-development-company__1iqZG","prototyping-services":"styles_prototyping-services__wiUXP","lending-software-development":"styles_lending-software-development___sSJi","trading-software-development":"styles_trading-software-development__wnuIW","penetration-testing":"styles_penetration-testing__Z6rew","pricing":"styles_pricing__ykbor","e-wallet-app-development":"styles_e-wallet-app-development__LF9TC","banking-software-development-company":"styles_banking-software-development-company___7i6h","delivery-quality-in-yellow":"styles_delivery-quality-in-yellow__GNDyR","crowdfunding-platform-development-company":"styles_crowdfunding-platform-development-company__kBs79","payment-gateway-development-company":"styles_payment-gateway-development-company__neZq8","pwa-development-services":"styles_pwa-development-services__4w4hE","software-quality-assurance-services":"styles_software-quality-assurance-services__dy0fs","billing-software-development-services":"styles_billing-software-development-services__ngnQA","software-development-columbus":"styles_software-development-columbus__WIYDc","software-development-new-orleans":"styles_software-development-new-orleans__WgCSD","software-development-tulsa":"styles_software-development-tulsa__2QzbZ","software-development-minneapolis":"styles_software-development-minneapolis__DYZRk","software-development-miami":"styles_software-development-miami__FYRvG","software-development-washington":"styles_software-development-washington__atTZy","software-development-oklahoma":"styles_software-development-oklahoma__PllOm","software-development-omaha":"styles_software-development-omaha__IAS9z","software-development-nashville":"styles_software-development-nashville__S9H0p","software-development-raleigh":"styles_software-development-raleigh__jqfZx","ai-software-development-services":"styles_ai-software-development-services__tDzeF","computer-vision-services":"styles_computer-vision-services__Xbaou","ai-agent-development-services":"styles_ai-agent-development-services__xht_d","natural-language-processing-as-a-service":"styles_natural-language-processing-as-a-service__UYc6H","robotic-process-automation-services":"styles_robotic-process-automation-services__i_GK_","rag-development-services":"styles_rag-development-services__c5OqF","mlops-development-services":"styles_mlops-development-services__FELSI","button-2":"styles_button-2__mZWTt","generative-ai-services":"styles_generative-ai-services__Eultw","deep-learning":"styles_deep-learning__4cEQL","ai-chatbot-development-services":"styles_ai-chatbot-development-services__Alubn","software-development-services-for-various-industries":"styles_software-development-services-for-various-industries__YOeeN","ai-staff-augmentation-services":"styles_ai-staff-augmentation-services__SkALM","ai-consulting-services":"styles_ai-consulting-services__T8RM3","software-development-services-for-startups":"styles_software-development-services-for-startups__hfe__","logistics-software-development-services":"styles_logistics-software-development-services__vPnpV","e-commerce-development":"styles_e-commerce-development__GPfWK","travel-and-hospitality-software-development":"styles_travel-and-hospitality-software-development__EicZ_","educational-software-development-services":"styles_educational-software-development-services__9eovz","entertainment-software-development-services":"styles_entertainment-software-development-services__Eu1K6","healthcare-software-development-services":"styles_healthcare-software-development-services__yAIGF","software-development-engagement-models":"styles_software-development-engagement-models__B7L8e","david-vs-goliath":"styles_david-vs-goliath__aRhiC","llm-development-services":"styles_llm-development-services__qQeYk","ai-voice-assistant-development-services":"styles_ai-voice-assistant-development-services__L8bfK","ai-copilot-development-services":"styles_ai-copilot-development-services__CbWOp","services":"styles_services__9a5qB","ai-managed-pod":"styles_ai-managed-pod__cN_lJ","formattedDescription":"styles_formattedDescription__a_4Mi","pageSubtitleSmall":"styles_pageSubtitleSmall__wR0r0","bundleImagesContainer":"styles_bundleImagesContainer__lnJ5G","bundleImage":"styles_bundleImage__TAegZ","ai-assessments":"styles_ai-assessments__0fp31"};

/***/ }),

/***/ 69123:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h2":"styles_h2__BMuQY","h3":"styles_h3__wh4p0","paragraph":"styles_paragraph__9NG9P","a":"styles_a__QRxdK","ul":"styles_ul__esYyW","ol":"styles_ol__ue_m_","quote":"styles_quote___48vb","imageWrapper":"styles_imageWrapper__qFsnC","fullImage":"styles_fullImage__qANu4","normalImage":"styles_normalImage__eNnG6","image":"styles_image__Lejqj","photoCaption":"styles_photoCaption__WUS8x","videoSection":"styles_videoSection__g6E1A"};

/***/ })

}]);